import { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';

const STUDENTS = [
  {
    q: 'Quanto custa usar?',
    a: 'Nada. Buscar e pedir contato é grátis. O valor das aulas você combina direto com o personal, sem intermediários.',
  },
  {
    q: 'Por que preciso entrar com o Google para pedir contato?',
    a: 'Para os personais receberem pedidos de pessoas reais. O Google só confirma quem é você: não temos acesso aos seus e-mails nem aos seus arquivos.',
  },
  {
    q: 'Quem vê o meu telefone e o meu e-mail?',
    a: 'Só o personal para quem você pediu contato, e só depois que ele aceitar o pedido. Nesse momento você também recebe o WhatsApp dele.',
  },
  {
    q: 'Por que posso ter só 5 pedidos em aberto?',
    a: 'Para ninguém disparar pedidos em massa. Quando um personal responde (ou o pedido expira em 14 dias), a vaga volta para você.',
  },
  {
    q: 'O que quer dizer "CREF verificado"?',
    a: 'Nossa equipe conferiu, na consulta pública do conselho regional (CREF), que o registro informado existe e está ativo. Perfis sem o selo ainda estão em verificação.',
  },
];

const TRAINERS = [
  {
    q: 'Criar o perfil é grátis mesmo?',
    a: 'Sim. Aparecer na busca e receber pedidos de alunos é grátis e sem limite de pedidos.',
  },
  {
    q: 'O que é pago?',
    a: 'Só a plataforma com a sua marca, que é opcional: o app dos seus alunos com o seu nome e as suas cores, com treinos, nutrição, evolução e IA. O perfil no marketplace e os pedidos de alunos são grátis. O pagamento das aulas é combinado entre você e o aluno e não passa por nós.',
  },
  {
    q: 'Como funciona a verificação do CREF?',
    a: 'Você informa o número, a categoria (G ou P) e o estado do seu registro. A equipe confere na consulta pública do conselho e o seu perfil ganha o selo de verificado. Se o número mudar, o perfil volta para a verificação.',
  },
  {
    q: 'Vou poder procurar alunos?',
    a: 'Em breve. A busca de alunos vai chegar como um recurso para assinantes da plataforma, com as mesmas regras contra spam.',
  },
  {
    q: 'O que é o app com a minha marca?',
    a: 'É a plataforma completa, vendida por assinatura: seus alunos acessam treinos, nutrição, evolução e IA num app com o seu nome, suas cores e o seu endereço. O perfil no marketplace continua grátis com ou sem ela.',
  },
];

export function Faq({ initialTab = 0 }: { initialTab?: 0 | 1 }) {
  const [tab, setTab] = useState<number>(initialTab);
  const items = tab === 0 ? STUDENTS : TRAINERS;
  return (
    <Container
      component="section"
      maxWidth="md"
      sx={{ py: { xs: 8, md: 10 } }}
      aria-labelledby="faq"
    >
      <Typography id="faq" variant="h3" component="h2" sx={{ textAlign: 'center', mb: 3 }}>
        Perguntas frequentes
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Tabs value={tab} onChange={(_, value: number) => setTab(value)} aria-label="Público">
          <Tab label="Para alunos" />
          <Tab label="Para personais" />
        </Tabs>
      </Box>
      {items.map((item) => (
        <Accordion
          key={item.q}
          disableGutters
          variant="outlined"
          sx={{ mb: 1, '&::before': { display: 'none' } }}
        >
          <AccordionSummary expandIcon={<ExpandMoreRounded />}>
            <Typography variant="subtitle1">{item.q}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="text.secondary">{item.a}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}
